export const DESKTOP_QR_DISPLAY_SIZES = Object.freeze([176, 224, 304]);
export const MOBILE_QR_DISPLAY_SIZES = Object.freeze([128, 176, 224]);

function clamp(value, low, high) {
  return low > high ? (low + high) / 2 : Math.max(low, Math.min(high, value));
}

export function clampQrOffset(offset, frame, stage, drag = { x: 0, y: 0 }) {
  const margin = 24;
  return {
    x: clamp(offset.x, stage.left + margin - frame.left - drag.x,
      stage.right - margin - frame.left - frame.width - drag.x),
    y: clamp(offset.y, stage.top + margin - frame.top - drag.y,
      stage.bottom - margin - frame.top - frame.height - drag.y),
  };
}

export function qrCursorTarget(cursor, frame, stage, drag = { x: 0, y: 0 }) {
  return clampQrOffset({
    x: (cursor.x - frame.left - frame.width / 2 - drag.x) * 0.32,
    y: (cursor.y - frame.top - frame.height / 2 - drag.y) * 0.32,
  }, frame, stage, drag);
}
